import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { getUser } from "../../../Utils/externalFunctions";
import { timeToast } from "../../../Constant";
import { toast } from "react-toastify";
import {
  APISentSuccessMsg,
  getFillAllFieldError,
  getItemCreateSuccessMsg,
} from "../../../Constant/Message";
import DATA_TYPE from "../../../Constant/DataType";
import { useThemeContext } from "../../../Context/ThemeContext";
import { TextAreaField } from "../../../CommonElements";
toast.configure();

function ModalDaftarAkun({
  getRencImp,
  unitKerja,
  kegiatan,
  daftarAkun,
  modal,
  toggle,
}) {
  const axiosInstance = useAxios();
  const [unitKerjaOpt, setUnitKerjaOpt] = useState([]);
  const [anggaranBUK, setAnggaranBUK] = useState([]);
  const [kegiatanOpt, setKegiatanOpt] = useState([]);
  const [daftarAkunOpt, setDaftarAkunOpt] = useState([]);
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [formData, setFormData] = useState({
    diajukan_oleh: getUser(),
    id_anggaran_bulanan_unit_kerja: "1911",
    nm_org: "",
    id_satuan: 175,
    id_sub_kegiatan: 25038,
    id_jenis_pembayaran: "KO",
    id_akun: 783,
    id_sumber_dana: 51,
    id_jenis_kegiatan: "Rutin",
    anggaran: "0",
    anggaran_realokasi: "0",
    anggaran_sebelumnya: "0",
    anggaran_tersisa: "0",
    biaya_satuan: "0",
    kd_keg: "",
    nm_keg: "",
    kd_akun: "",
    nm_akun: "",
    bulan_sumber_dana: 51,
  });

  useEffect(async () => {
    const response = await axiosInstance.get("anggaranbuk/");
    if (response.status === 200) {
      setAnggaranBUK(response.data);
    } else {
      console.log("Error when fetching data");
    }
  }, []);

  useEffect(() => {
    if (unitKerja.length === 1) {
      setFormData((prevState) => ({
        ...prevState,
        nm_org: unitKerja[0].nama_unit_kerja,
      }));
    }

    setUnitKerjaOpt(
      unitKerja.map((item) => ({
        value: item.nama_unit_kerja,
        label: item.nama_unit_kerja,
        name: "nm_org",
      }))
    );
  }, [unitKerja]);

  useEffect(() => {
    setKegiatanOpt(
      kegiatan.map((item) => ({
        value: item.nama_kegiatan,
        label: item.kode_kegiatan + " - " + item.nama_kegiatan,
        name: "nm_keg",
      }))
    );
  }, [kegiatan]);

  useEffect(() => {
    setDaftarAkunOpt(
      daftarAkun.map((item) => ({
        value: item.nama_akun,
        label: item.kode_akun + " - " + item.nama_akun,
        name: "nm_akun",
      }))
    );
  }, [daftarAkun]);

  const handleChange = (e) => {
    if (e === null) {
      return;
    }

    let { name, value } = e;

    if (name === "nm_keg") {
      let kegiatanobj = kegiatan.find((x) => x.nama_kegiatan === value);
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        kd_keg: kegiatanobj.kode_kegiatan,
      }));
    } else if (name === "nm_akun") {
      let akun = daftarAkun.find((x) => x.nama_akun === value);
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        kd_akun: akun.kode_akun,
      }));
    } else if (name === "nm_org") {
      let unit = unitKerja.find((uk) => uk.nama_unit_kerja === value);
      let bukpk = anggaranBUK.find((abuk) => abuk.id_unit_kerja === value);
      setFormData((prevState) => ({
        ...prevState,
        nm_org: value,
        id_anggaran_bulanan_unit_kerja: bukpk.pk,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    if (unitKerja.length === 1) {
      let unit = unitKerja.find(
        (uk) => uk.nama_unit_kerja === unitKerja[0].nama_unit_kerja
      );
      setFormData((prevState) => ({
        ...prevState,
        nm_org: unitKerja[0].nama_unit_kerja,
        id_anggaran_bulanan_unit_kerja: unit.anggaran[0],
      }));
    }
  }, [unitKerja]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.nm_org === "" ||
      formData.nm_keg === "" ||
      formData.nm_akun === "" ||
      formData.untuk_tanggal === "" ||
      formData.nilai === "" ||
      formData.keterangan === ""
    ) {
      toast.error(getFillAllFieldError(), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      return;
    }

    try {
      setWaitingForSubmit(true);
      const response = await axiosInstance.post("rencanaimp/", formData);
      if (response.status === 201) {
        console.log(APISentSuccessMsg);
        toast.success(getItemCreateSuccessMsg(DATA_TYPE.Akun), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
        setWaitingForSubmit(false);
        getRencImp();
        toggle();
      }
    } catch (e) {
      console.error(e);
      toast.error(e.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      setWaitingForSubmit(false);
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
      <ModalHeader toggle={toggle}>Akun Baru</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="id_unit_kerja">DPSJ</Label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable
              isSearchable
              isDisabled={unitKerjaOpt.length === 1}
              name="id_unit_kerja"
              defaultValue={unitKerjaOpt.length === 1 && unitKerjaOpt[0]}
              options={unitKerjaOpt}
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="nm_keg">Kegiatan</Label>

            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable
              isSearchable
              isDisabled={kegiatanOpt === 1}
              name="nm_keg"
              defaultValue={kegiatanOpt === 1 && kegiatanOpt[0]}
              options={kegiatanOpt}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="nm_akun">Akun</Label>

            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable
              isSearchable
              isDisabled={daftarAkunOpt === 1}
              name="nm_akun"
              defaultValue={daftarAkunOpt === 1 && daftarAkunOpt[0]}
              options={daftarAkunOpt}
              onChange={handleChange}
            />
          </FormGroup>

          <TextAreaField
            label={"Keterangan"}
            name={"keterangan"}
            onChange={(e) => handleChange(e)}
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={waitingForSubmit}
        >
          Submit
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalDaftarAkun;
